import React, { useEffect, useState } from 'react';
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import Cancel from './../../../../assets/icons/close.png';
import itemImg from './../../../../assets/icons/menu.png';
import SchedulerDetailsTable from "../SchedulerView/SchedulerDetailsViewWithTable/SchedulerDetailsTable.tsx";
import CreateNewSchedule from "../SchedulerView/ScheduleItemDialog/CreateNewSchedule/CreateNewSchedule.tsx";
import { ToastContainer, toast } from 'react-toastify';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import {
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab,
  Autocomplete,
  TextField,
} from '@mui/material';

function MenuSchedulerSelectDialog(props) {
  const [schedulerDatas, setSchedulerDatas] = useState([]);
  const [scheduleSelections, setScheduleSelections] = useState(props.prevScheduleSelecection  || {});
  const [selectedTab, setSelectedTab] = useState(0);
  const [scheduleDetails, setScheduleDetails] = useState({}); 
  const [open, setOpen] = React.useState(false);
  const apiAddress = process.env.REACT_APP_SECRET;
  

  useEffect(() => {
    const fetchInitialSchedules = async () => {
      const restaurantId = props.restaurantSelected[selectedTab]?.id;
      const initialSelection = scheduleSelections[restaurantId];
  
      if (restaurantId && initialSelection) {
        await fetchScheduleDetails(restaurantId, [initialSelection]);
      }
    };
  
    fetchInitialSchedules();
  }, [props.restaurantSelected, selectedTab, scheduleSelections])



  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleAddItem = (AddItemData) => {
    setOpen(AddItemData);
    loadData();
  };
  console.log(props);
  useEffect(() => {
    loadData();
  }, []);


  const handleSave = () => {
    if (props.onSave) {
      props.onSave(scheduleSelections); 
    }
    props.onClose();
  };

  useEffect(() => {
    console.log(scheduleSelections)
  }, [scheduleSelections]);

  const loadData = async () => {
    try {
      const response = await axios.get(`${apiAddress}/api/Schedule`);
      const temp = response.data.map((dt) => ({
        id: dt.scheduleId,
        title: dt.scheduleName,
        contentId: null,
      }));
      setSchedulerDatas(temp);
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data || "Failed to load schedules", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };

  const handleScheduleChange = async (restaurantId, newValue) => {
    setScheduleSelections((prev) => ({
      ...prev,
      [restaurantId]: newValue,
    }));

    if (newValue) {
      await fetchScheduleDetails(restaurantId, [newValue]);
    } else {
      setScheduleDetails((prev) => ({
        ...prev,
        [restaurantId]: { addedSchedulers: [], conflictedSchedulers: [] },
      }));
    }
  };

  const fetchScheduleDetails = async (restaurantId, selectedSchedules) => {
    const ids = selectedSchedules.map((item) => item.id);

    try {
      const response = await axios.post(`${apiAddress}/api/Schedule/getschedulebyidlist`, ids);
      setScheduleDetails((prev) => ({
        ...prev,
        [restaurantId]: {
          addedSchedulers: response.data.schedulerDatas,
          conflictedSchedulers: response.data.conflictedData,
        },
      }));
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data || "Failed to fetch schedule details", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleClose = () => {
    props.onClose();
  };

  return (
    <Dialog maxWidth="md" fullWidth={true} open={props.open} onClose={handleClose}>
      <Grid container>
        <Grid item xs={6}>
          <DialogTitle>
            <div className="d-flex" style={{ gap: "8px" }}>
              <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
              <span style={{ color: "#2a7fd4" }}>GoTaste :- Menu Scheduler Select</span>
            </div>
          </DialogTitle>
        </Grid>
        <Grid item xs={6}>
          <DialogActions>
            <Button onClick={handleClose}>
              <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
      <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {props.restaurantSelected.map((restaurant) => (
            <Tab key={restaurant.id} label={restaurant.title} />
          ))}
        </Tabs>
        <div style={{ marginTop: "16px" }}>
          {props.restaurantSelected[selectedTab] && (
            <>
            <Grid container>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>Select Schedule</Typography>
              </Grid>
              <Grid item xs={7} style={{ paddingTop: "0.5rem" }}>
                <Autocomplete
                  id={`single-select-${props.restaurantSelected[selectedTab].id}`}
                  options={schedulerDatas}
                  getOptionLabel={(option) => option.title}
                  value={scheduleSelections[props.restaurantSelected[selectedTab].id] || null}
                  onChange={(event, newValue) =>
                    handleScheduleChange(props.restaurantSelected[selectedTab].id, newValue)
                  }
                  renderInput={(params) => <TextField {...params} label="Select Schedule" variant="outlined" />}
                  sx={{ width: "100%", paddingY: ".5rem" }}
                />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: "1rem" }}>
              <button
                      className="btn "
                      style={{ color: "blue", fontSize: "1.2rem" }}
                      onClick={() => {
                        setOpen(true);
                      }}
                    >
                      {" "}
                      +Create New Schedule
                    </button>
          </Grid>
            </Grid>
            
          </>
          )}
        </div>
        
        {props.restaurantSelected[selectedTab] &&
          scheduleDetails[props.restaurantSelected[selectedTab].id]?.addedSchedulers?.length > 0 && (
            <SchedulerDetailsTable
              addedtempSchedulers={
                scheduleDetails[props.restaurantSelected[selectedTab].id]?.addedSchedulers || []
              }
            />
          )}
      </DialogContent>
      <CreateNewSchedule
        open={open}
        onHandleAddItem={handleAddItem}
        title={props.title}
      />
      <DialogActions>
      <Button onClick={handleSave} color="primary">
          Save
        </Button>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MenuSchedulerSelectDialog;
